import { render, staticRenderFns } from "./message_modify.vue?vue&type=template&id=01d8d7be&scoped=true&"
import script from "./message_modify.vue?vue&type=script&lang=js&"
export * from "./message_modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8d7be",
  null
  
)

export default component.exports